import {styled} from "@mui/material";

const AdminLayoutContent = styled('div')({
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
});

export default AdminLayoutContent;
